import axios, { AxiosError } from "axios";

export interface UploadResponse {
  cdn_url: string;
  file_name: string;
  resource_type: string;
  size_in_kb: string;
  type: string;
}

export const uploadToCdn = async (
  file: File,
  presignedUrl: any,
  onProgress?: (progress: number) => void
): Promise<UploadResponse> => {

  const formData = new FormData();
  Object.entries(presignedUrl.post_object.fields).forEach(([key, value]) => {
    formData.append(key, value as string);
  });
  formData.append("acl", "public-read");
  // Append the actual file
  formData.append("file", new Blob([file], { type: file.type }));
  await axios.post(presignedUrl.post_object.url, formData);

  try {
    await axios.post(
      presignedUrl.post_object.url,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total!);
          onProgress?.(percentCompleted);
          console.log(`Upload Progress: ${percentCompleted}%`);
        },
      }
    );

    return {
      cdn_url: presignedUrl.public_url,
      file_name: file.name,
      resource_type: file.type.startsWith("image") ? "image" : file.type === "application/pdf" ? "document" : "video",
      size_in_kb: (file.size / 1024).toFixed(0),
      type: file.type.startsWith("image") ? "image" : file.type === "application/pdf" ? "document" : "video",
    };
  } catch (error) {
    if (error instanceof AxiosError) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        throw new Error(`Upload failed: ${error.response.data.message || error.message}`);
      } else if (error.request) {
        // The request was made but no response was received
        throw new Error('No response received from server');
      }
    }
    // Something happened in setting up the request that triggered an Error
    throw new Error('Upload failed: ' + (error as Error).message);
  }
};